import { isAxiosError, AxiosError } from 'axios'

// Webviews (FB in-app browser, Safari) abort in-flight XHRs on navigation or
// brief offline, which axios reports as ERR_NETWORK with no response. Attach
// as the catch handler on fire-and-forget dispatches whose failure the app
// tolerates; HTTP error responses still rethrow and surface as before.
export const ignoreNetworkError = (error: unknown): void => {
  if (isAxiosError(error) && error.code === AxiosError.ERR_NETWORK) return
  throw error
}
